import { call, put, takeLatest, fork, all } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as Func from "../helpers/functions";
import { parseListRequestParamsCameo, getLocaleFullName } from '../utils/commonUtils';
import i18n from '../constants/initLng';
import { notification } from 'antd'
import history from '../helpers/history';
import * as TicketAction from '../actions/ticketAction';
import * as TicketService from './../services/ticketService';
import { PATHS } from '../constants/Define';

function* getListTicket() {
    yield takeLatest(Types.TICKET_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParamsCameo(action.params || {});
        const result = yield call(TicketService.getTickets, params);
        yield put(TicketAction.setTicketList(result));
    }, errorHandleTicket(Types.TICKET_FAIL)))
}

function* getTicketDetail() {
    yield takeLatest(Types.TICKET_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(TicketService.getTicketDetail, action.id);
        yield put(TicketAction.setTicketDetail(result));
    }, errorHandleTicket(Types.TICKET_FAIL)))
}

function* updateTicket() {
    yield takeLatest(Types.TICKET_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(TicketService.updateTicket, action.ticket);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.updateSuccess')}`, description: `${i18n.t('item.ticket.title')} "${action.ticket.ticketName}"` })
        yield put(TicketAction.setTicketDetail(action.ticket));
    }, errorHandleTicket(Types.TICKET_FAIL)))
}

// MY TICKET
function* getListMyTicket() {
    yield takeLatest(Types.TICKET_MY_LIST_ACTION, Func.sagaWrapper(function* (action) {
        // const params = parseListRequestParamsCameo(action.params || {});
        const result = yield call(TicketService.getMyTickets);
        yield put(TicketAction.setMyTicketList(result));
    }, errorHandleTicket(Types.TICKET_FAIL)))
}

function* getMyTicketDetail() {
    yield takeLatest(Types.TICKET_MY_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(TicketService.getMyTicketDetail, action.id);
        yield put(TicketAction.setMyTicketDetail(result));
    }, errorHandleTicket(Types.TICKET_FAIL)))
}

function* updateMyTicket() {
    yield takeLatest(Types.TICKET_MY_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(TicketService.updateMyTicket, action.myTicket);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.updateSuccess')}`, description: `${i18n.t('item.ticket.title')} "${action.myTicket.ticketName}"` })
        yield put(TicketAction.setMyTicketDetail(action.myTicket));
        yield put({ type: Types.TICKET_MY_LIST_ACTION })
    }, errorHandleTicket(Types.TICKET_FAIL)))
}

// TICKET ASSIGN CONFIG
function* getListTicketAssignConfig() {
    yield takeLatest(Types.TICKET_ASSIGN_CONFIG_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParamsCameo(action.params || {});
        const result = yield call(TicketService.getTicketAssignConfigs, params);
        yield put(TicketAction.setTicketAssignConfigList(result));
    }, errorHandleTicket(Types.TICKET_FAIL)))
}

function* getTicketAssignConfigDetail() {
    yield takeLatest(Types.TICKET_ASSIGN_CONFIG_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(TicketService.getTicketAssignConfigDetail, action.id);
        yield put(TicketAction.setTicketAssignConfigDetail(result));
    }, errorHandleTicket(Types.TICKET_FAIL)))
}

function* updateTicketAssignConfig() {
    yield takeLatest(Types.TICKET_ASSIGN_CONFIG_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(TicketService.updateTicketAssignConfig, action.ticketAssignConfig);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'),
            action.ticketAssignConfig.userDetail && getLocaleFullName(action.ticketAssignConfig.userDetail.firstname, action.ticketAssignConfig.userDetail.lastname));
        yield put({ type: Types.TICKET_ASSIGN_CONFIG_UPDATE_SUCCESS });
    }, errorHandleTicket(Types.TICKET_FAIL)))
}

function* createTicketAssignConfig() {
    yield takeLatest(Types.TICKET_ASSIGN_CONFIG_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(TicketService.createTicketAssignConfig, action.ticketAssignConfig);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'),
            action.ticketAssignConfig.userDetail && getLocaleFullName(action.ticketAssignConfig.userDetail.firstname, action.ticketAssignConfig.userDetail.lastname));
        yield put({ type: Types.TICKET_ASSIGN_CONFIG_CREATE_SUCCESS });
        history.go(PATHS.TICKET_ASSIGN_CONFIG.LIST.path)
    }, errorHandleTicket(Types.TICKET_FAIL)))
}

function* deleteTicketAssignConfig() {
    yield takeLatest(Types.TICKET_ASSIGN_CONFIG_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(TicketService.deleteTicketAssignConfig, action.ticketAssignConfig.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'));
        yield put({ type: Types.TICKET_ASSIGN_CONFIG_DELETE_SUCCESS });
        yield put({ type: Types.TICKET_ASSIGN_CONFIG_LIST_ACTION, params: action.refreshParams });
    }, errorHandleTicket(Types.TICKET_FAIL)))
}

function errorHandleTicket(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'ticket');
}


export function* ticketSaga() {
    yield all([
        fork(getListTicket),
        fork(getTicketDetail),
        fork(updateTicket),
        //My ticket
        fork(getListMyTicket),
        fork(getMyTicketDetail),
        fork(updateMyTicket),
        //Ticket assign config
        fork(getListTicketAssignConfig),
        fork(getTicketAssignConfigDetail),
        fork(updateTicketAssignConfig),
        fork(createTicketAssignConfig),
        fork(deleteTicketAssignConfig),
    ])
}
